import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {

  fetchAllIntegrations({ commit }, queryParams = null) {
    return new Promise((resolve, reject) => {
      API.integrations.getAll(
        queryParams,
        "",
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchIntegrations({ commit }, includes = null) {
    return new Promise((resolve, reject) => {
      API.integrations.getIntegrations(
        includes,
        resp => {
          let integrations = resp.data.data;
          resolve(integrations);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  fetchIntegrationByUuid({ commit }, integrationUuid) {
    return new Promise((resolve, reject) => {
      API.integrations.getIntegrationByUuid(
        integrationUuid,
        resp => {
          let integration = resp.data.data[0];
          resolve(integration);
        },
        error => {
          reject(error.response);
        }
      );
    });
  },

  createNewImport({ commit }, newImportData) {
    return new Promise((resolve, reject) => {
      API.integrations.createNewImport(
        newImportData,
        resp => {
          let newImport = resp.data.data;
          resolve(newImport);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  storeObjects({ commit }, { objects, importUuid }) {
    return new Promise((resolve, reject) => {
      API.integrations.storeObjects(
        objects,
        importUuid,
        resp => {
          let object = resp.data.data;
          resolve(object);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getConflicts({ commit }, importUuid) {
    return new Promise((resolve, reject) => {
      API.integrations.getConflicts(
        importUuid,
        resp => {
          let objects = resp.data;
          resolve(objects);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchImportByUuid({ commit }, importUuid) {
    return new Promise((resolve, reject) => {
      API.integrations.getImportByUuid(
        importUuid,
        resp => {
          let object = resp.data.data[0];
          resolve(object);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  getImportNewObjects({ commit }, importUuid) {
    return new Promise((resolve, reject) => {
      API.integrations.getImportNewObjects(
        importUuid,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  syncWithExternalService({ commit }, assetReservationID) {
    return new Promise((resolve, reject) => {
      API.integrations.syncWithExternalService(
        assetReservationID,
        resp => {
          resolve(resp);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/integrations.js